import { useEffect, useRef } from 'react';
import type { FormIssue } from './form-feedback';

export function FormErrorSummary({ issue, id }: { issue: FormIssue | null; id: string }) {
  const summary = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (issue) summary.current?.focus();
  }, [issue]);
  if (!issue) return null;
  return (
    <div ref={summary} id={id} className="auth-error form-error-summary" role="alert" tabIndex={-1}>
      <p>{issue.summary}</p>
      {issue.field && (
        <a
          href={`#${issue.field}`}
          onClick={(event) => {
            event.preventDefault();
            document.getElementById(issue.field!)?.focus();
          }}
        >
          Đến ô cần kiểm tra
        </a>
      )}
      {issue.detail && (
        <details>
          <summary>Chi tiết phản hồi</summary>
          <p>{issue.detail}</p>
        </details>
      )}
    </div>
  );
}
